import Navbar from './components/Navbar'
import Hero from './components/Hero'
import Services from './components/Services'
import Numbers from './components/Numbers'
import Why from './components/Why'
import Who from './components/Who'
import Footer from './components/Footer'

function App() {
  return (
    <>
      <Navbar />
      <Hero />
      <Services />
      <Numbers />
      <Who />
      <Why />
      <Footer />
    </>
  )
}

export default App